import { History } from "history";
import { routerMiddleware } from "react-router-redux";
import {
  applyMiddleware,
  combineReducers,
  createStore,
  Store
} from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  Persistor,
  PersistPartial,
  persistReducer,
  persistStore
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk, { ThunkMiddleware } from "redux-thunk";

import {
  customersReducer,
  ICustomersStore
} from "src/core/customers/store/customers.reducer";
import {
  analyticsReducer,
  IAnalyticsStore
} from "src/core/analytics/store/analytics.reducer";
import {
  dropsReducer,
  IDropsStore
} from "src/core/drops/store/drops.reducer";
import {
  IListsStore,
  lists
} from "src/core/lists/store/lists.reducer";
import {
  INotificationsStore,
  notificationsReducer
} from "src/core/notifications/store/notifications.reducer";
import {
  IOrderStore,
  orders
} from "src/core/orders/store/orders.reducer";
import {
  IProductsStore,
  productsPersistConfig,
  productsReducer
} from "src/core/products/store/products.reducer";
import {
  ISchedulesStore,
  schedulesReducer
} from "src/core/schedules/store/schedules.reducer";
import {
  global,
  IGlobalStore
} from "src/core/shared/store/global/global.reducer";
import {
  IUsersStore,
  usersPersistConfig,
  usersReducer
} from "src/core/users/store/users.reducer";

export interface IStore {
  global: IGlobalStore;
  products: IProductsStore & PersistPartial;
  orders: IOrderStore;
  users: IUsersStore & PersistPartial;
  lists: IListsStore;
  schedules: ISchedulesStore;
  customers: ICustomersStore;
  drops: IDropsStore;
  notifications: INotificationsStore;
  analytics: IAnalyticsStore;
}
const middleware: any[] = [];

middleware.push(thunk as ThunkMiddleware<IStore, any>);

const rootReducer = () =>
  combineReducers({
    global,
    users: persistReducer(usersPersistConfig, usersReducer),
    products: persistReducer(productsPersistConfig, productsReducer),
    lists,
    schedules: schedulesReducer,
    orders,
    customers: customersReducer,
    drops: dropsReducer,
    notifications: notificationsReducer,
    analytics: analyticsReducer
  });

const persistConfig = {
  key: "root",
  storage,
  blacklist: [ "products" ]
};

export default (browserHistory: History<any>): { store: Store<IStore>; persistor: Persistor } => {
  const persistedReducer = persistReducer(persistConfig, rootReducer());

  middleware.push(routerMiddleware(browserHistory));

  const composeEnhancers = composeWithDevTools({});
  // eslint-disable-next-line @typescript-eslint/ban-types
  const store: Store<IStore> = createStore<IStore & PersistPartial, any, {}, {}>(persistedReducer, composeEnhancers(applyMiddleware(...middleware)));
  const persistor = persistStore(store);

  return {
    store,
    persistor
  };
};
